import React, { useState, useEffect } from 'react';
import { ResponsiveTreeMap } from '@nivo/treemap';
import {
	Flex, Box, Table, Thead, Tbody, Tr, Th, Td, Heading, Text, Icon,
} from '@chakra-ui/react';
import { FontAwesomeIcon as Fa } from '@fortawesome/react-fontawesome';
import {
	faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import Page from '../components/Page';
import { serversideInstance as axios } from '../utils/axios';

export default function Home({ count }) {
	const [data, setData] = useState({});

	useEffect(() => {
		if (!count) return;
		setData({
			name: '開放資料',
			children: count.sort((a, b) => b.count - a.count).map((x) => ({
				name: x.name,
				value: x.count,
			})),
		});
	}, [count]);

	return (
		<Page>
			<Flex mt={4}>
				<Box w="100%">
					<div style={{ height: '500px' }}>
						<ResponsiveTreeMap
							data={data}
							identity="name"
							value="value"
							valueFormat=".02s"
							tile="binary"
							margin={{
								top: 10, right: 10, bottom: 10, left: 10,
							}}
							label="id"
							orientLabel={false}
							labelSkipSize={12}
							labelTextColor={{ from: 'color', modifiers: [['darker', 1.2]] }}
							parentLabelTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
							borderColor={{ from: 'color', modifiers: [['darker', 0.1]] }}
						/>
					</div>
				</Box>
			</Flex>
			<Flex>
				<Box w="100%" mt={8}>
					<Heading as="h2" fontSize="lg" fontWeight={600} mb={3}>資料來源</Heading>
					{count && (
						<Table variant="striped">
							<Thead>
								<Tr>
									<Th>資料平臺</Th>
									<Th d={['none', 'block']}>網址</Th>
									<Th textAlign="right">資料集數量</Th>
									<Th>{' '}</Th>
								</Tr>
							</Thead>
							<Tbody>
								{count.sort((a, b) => b.count - a.count).map((x) => (
									<Tr>
										<Td>
											<Text fontSize={['sm', 'md']}>{x.name}</Text>
											<Text d={['block', 'none']} fontSize="xs" fontWeight={600} color="#777">
												{x?.url?.[0]?.replace(/https?:\/\//g, '')}
											</Text>
										</Td>
										<Td d={['none', 'block']}>{x?.url?.[0]?.replace(/https?:\/\//g, '')}</Td>
										<Td textAlign="right" fontSize={['sm', 'md']}>
											{x.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
											{' '}
											筆
										</Td>
										<Td>
											<a href={x.url} target="_blank" rel="noreferrer">
												<Icon as={Fa} icon={faExternalLinkAlt} ml={1} />
											</a>
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					)}
				</Box>
			</Flex>
		</Page>
	);
}

export const getStaticProps = async () => {
	const { data: count } = await axios.get('/api/v1/summary');

	return {
		props: {
			count,
		},
		revalidate: 600,
	};
};
